import type { DailySale } from "../../../../../hooks/requests/metrics/dailySales";
import { formatPrice } from "../../../../../utils/format";
import { Tooltip } from "../../../ui/tooltip";

export const SaleItem = ({ sale }: { sale: DailySale }) => {
  const items = sale.items ?? [];
  const hasMultiple = items.length > 1;

  const getItemName = () => {
    if (sale.type === "plan") return sale.planName;
    if (sale.type === "food") return sale.foodName;
    if (sale.type === "merchandise") return sale.productName;
    return "";
  };

  const getCountLabel = () => {
    if (sale.type === "plan") return `${items.length} planes`;
    if (sale.type === "food") return `${items.length} ítems`;
    return `${items.length} productos`;
  };

  const getTypeConfig = () => {
    switch (sale.type) {
      case "plan":
        return {
          text: "Plan",
          color: "text-[var(--metric-ticket)]",
          bg: "bg-[var(--metric-ticket-bg)]",
        };
      case "food":
        return {
          text: "Alimentación",
          color: "text-[var(--metric-food)]",
          bg: "bg-[var(--metric-food-bg)]",
        };
      case "merchandise":
        return {
          text: "Producto",
          color: "text-[var(--metric-products)]",
          bg: "bg-[var(--metric-products-bg)]",
        };
      default:
        return {
          text: "",
          color: "",
          bg: "",
        };
    }
  };

  const typeConfig = getTypeConfig();

  return (
    <div className="bg-global-overlay-secondary rounded-md p-2 border border-global-secondary hover:border-global-accent/30 transition-colors">
      <div className="flex items-center justify-between gap-1.5 mb-1">
        <p className="text-size-2xs font-medium text-global-primary truncate flex-1">
          {sale.clientName}
        </p>
        <span
          className={`px-1 py-0.5 rounded text-size-2xs font-medium ${typeConfig.color} ${typeConfig.bg}`}
        >
          {typeConfig.text}
        </span>
      </div>
      {hasMultiple ? (
        <div className="flex items-center gap-1.5">
          <p className="text-size-2xs text-global-tertiary truncate">
            {getCountLabel()}
          </p>
          <Tooltip
            content={
              <ul className="space-y-0.5">
                {items.map((item, i) => (
                  <li key={i} className="flex justify-between gap-3">
                    <span>{item.name}</span>
                    <span className="text-global-secondary tabular-nums">
                      × {item.quantity}
                    </span>
                  </li>
                ))}
              </ul>
            }
          >
            <button
              type="button"
              aria-label="Ver detalle de productos"
              className="text-global-secondary hover:text-global-primary transition-colors shrink-0"
            >
              <svg
                className="w-3.5 h-3.5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
              </svg>
            </button>
          </Tooltip>
        </div>
      ) : (
        <p className="text-size-2xs text-global-tertiary truncate">
          {getItemName()}
        </p>
      )}
      <div className="flex items-center justify-between mt-1">
        <span className="text-size-2xs text-global-muted">{sale.time}</span>
        <span className="text-size-2xs font-medium text-global-secondary">
          ${formatPrice(sale.amount)}
        </span>
      </div>
    </div>
  );
};
